// extracted by mini-css-extract-plugin
export var headerCell = "_52-1";
export var loadingSpinnerContainer = "_52-4";
export var rowWrapper = "_52-3";
export var standaloneTable = "_52-5";
export var table = "_52-0";
export var white = "_52-2";